import { useAppConfig } from '@plato/app-core/hooks/use-app-config';

/**
 * Whether Commercial Scopes are reachable for this user: the permission (Super
 * Manager) and the tenant's rollout flag together. Gates the Organisation
 * section in the settings menu, the team structure route, and the
 * `hasOrganisation` property on `settings_menu_opened` — one expression, so the
 * three cannot drift. Distinct from `canManageCommercialScopes`, which is the
 * role half on its own.
 */
export function useCommercialScopesEnabled(): boolean {
    const { canManageCommercialScopes, enableCommercialScopes } = useAppConfig();

    return canManageCommercialScopes && enableCommercialScopes;
}
